import config from '../config';

const mapOptions = {
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v10',
  center: [12, 50],
  zoom: 3,
  accessToken: config.mapboxToken
};

export default mapOptions;
